/*
 * @Author: edvardchen
 * @Date: 2018-02-26 11:13:11
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-02-26 12:05:46
 */

// @flow
/* eslint-disable import/prefer-default-export */

const detected = {};

export function supportPassive() {
  if (detected.passive !== undefined) {
    return detected.passive;
  }

  // first time
  let passive = false;
  try {
    const opts = Object.defineProperty(
      {},
      'passive',
      ({
        get: () => {
          passive = true;
        },
      }: Object),
    );
    window.addEventListener('test', null, opts);
    window.removeEventListener('test', null, opts);
  } catch (e) {
    /* ignore */
  }
  detected.passive = passive;
  return passive;
}
